import * as types from './habitese.actionType';
import * as commonActionType from '@common/store/common/common.actionsType';
import store from '@common/store/store';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  NumeroProjeto: undefined,
  AnoProjeto: undefined,
  NumeroHabitese: undefined,
  DataEmissaoHabitese: undefined,
  DadosHabitese: {},
});

const reduce = (state = initialState, action = {}) => {
  let payload = action.payload;
  switch (action.type) {
    case commonActionType.RESET:
      return initialState;
    case types.SET_HABITESE:
      return state.merge(payload);
    case types.SET_DADOS_HABITESE:
      return state.merge({ DadosHabitese: payload });
    case types.HABITESE_RESET:
      return initialState;
    default:
      return state;
  }
};

store.registerDynamicModule('habitese', reduce);
